import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

export const root = (theme: Theme) => css`
  background: ${theme.palette.background.accent};
`;

export const endSection = (theme: Theme) => css`
  border-start-start-radius: ${theme.borderRadius.xl};
  border-start-end-radius: ${theme.borderRadius.xl};
  background: ${theme.palette.background.main};
`;
